import React, { FC } from 'react';
import { getUserLang } from '@mb/lib';
import type { Event } from '@mb/types';
import { useIntl } from 'react-intl';
import { getDateFormatted } from '../../../Events/helpers/getDateFormatted';
import { definedTranslation } from '../../i18n';

interface EventHeaderProps {
  event: Event | null;
}

export const EventHeader: FC<EventHeaderProps> = ({ event }) => {
  const intl = useIntl();
  const btnLabel = intl?.formatMessage(definedTranslation.btnSpot);
  const userLang = getUserLang();
  if (!event) return null;
  return (
    <div className="w-full rounded-[20px] overflow-hidden relative">
      <img
        className="w-full h-[500px] object-cover md:hidden"
        src={event.hero_image_mobile}
        alt={event.title}
      />
      <img
        className="object-cover hidden w-full min-h-[350px] md:block"
        src={event.hero_image}
        alt={event.title}
      />
      <div
        className="header-event-info absolute left-0 top-0 flex
                flex-col self-stretch gap-8 z-[5] w-full h-full p-4 items-start lg:justify-end md:p-10"
      >
        {event?.header_logo && (
          <div className="lg:absolute top-10 left-10 z-[5]">
            <div className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-auto">
              <img
                src={event?.header_logo}
                srcSet={event?.header_logo}
                alt={event?.title}
                className="w-full h-auto object-contain max-h-[80px]"
              />
            </div>
          </div>
        )}
        <div className="header-event-text flex flex-col self-stretch gap-2">
          <p className="header-event-date text-white m-0">
            {getDateFormatted(event, userLang)}
          </p>
          <h1
            className="header-event-title text-white font-bold text-lgg lg:w-1/2 lg:text-xl
                        xl:text-[60px] xl:leading-[60px]"
          >
            {event.title}
          </h1>
          <p className="header-event-subtitle text-white m-0 md:text-lg">
            {event.subtitle}
          </p>
        </div>
        <a href={event.url} title={event.title} className="btn btn-ghost px-8">
          {btnLabel}
        </a>
      </div>
    </div>
  );
};
